import { async } from "q";
import axiosClient from "./axiosClient";

const serviceURL = "/qlkhambenh";
const technicalService = {
    getListTechnicalService: async (params) => {
      const url = serviceURL + `/dm-dich-vu/list-dm-dich-vu`;
      const response = await axiosClient.get(url, {
        params: params,
      });
      return response.data;
    },
    searchListTechnicalService: async (params) => {
      const url = serviceURL + `/dm-dich-vu/search-dm-dich-vu`;
      const response = await axiosClient.get(url, {
        params: params,
      });
      return response.data;
    },
    postTechnicalService: async (params) => {
      const url = serviceURL + `/dm-dich-vu`;
      const response = await axiosClient.post(url, params);
      return response.data;
    },
    putTechnicalService: async (params) => {
      const url = serviceURL + `/dm-dich-vu?id=${params.id}`;
      const response = await axiosClient.put(url, params);
      return response.data;
    },
    delTechnicalService: async (params) => {
      const url = serviceURL + `/dm-dich-vu`;
      const response = await axiosClient.delete(url, {params: params});
      return response.data;
    },
    getDanhMucNhomDVKT: async () => {
      const url = serviceURL + `/dm-nhom-dich-vu/list-dm-nhom-dich-vu`;
      const response = await axiosClient.get(url);
      return response.data;
    },
    getDanhMucLoaiDVKT: async () => {
      const url = serviceURL + `/dm-loai-dich-vu-ky-thuat/list-dm-loai-dich-vu-ky-thuat`;
      const response = await axiosClient.get(url);
      return response.data;
    },
    getDanhMucKhoa: async (params) => {
      const url =  `/hanhchinhnhansu/list-danh-muc-phong-ban`;
      const response = await axiosClient.get(url, {params: params});
      return response.data;
    },
    getDanhMucVTYT: async (params) => {
      const url =  `/store/VTYT-store/searchKey`;
      const response = await axiosClient.get(url, {params: params});
      return response.data;
    },
    getDanhMucTrangThai: async () => {
      const url = serviceURL + `/dm-tt-dich-vu-ky-thuat/list-dm-tt-dich-vu-ky-thuat`;
      const response = await axiosClient.get(url);
      return response.data;
    },
    postDanhMucNhomDVKT: async (params) => {
      const url = serviceURL + `/dm-nhom-dich-vu`;
      const response = await axiosClient.post(url, params);
      return response.data;
    },
    putDanhMucNhomDVKT: async (params) => {
      const url = serviceURL + `/dm-nhom-dich-vu?id=${params.id}`;
      const response = await axiosClient.put(url, params);
      return response.data;
    },
}

export default technicalService;